<template>
    <section class="content">
        <div class="row center-block">
            <!--<h2>Data tables</h2>-->
            <div class="col-md-12">
                <div class="box">
                    <div class="box-header">
                        <!--<h3 class="box-title">品牌列表</h3>-->
                        <h5><span class="text-red">＊</span> 此區為建立某張菜單所需的品項</h5>
                        <h5><span class="text-red">＊</span> 如需新增、編輯菜單的內容(商品名稱、分類排序...)，請至品牌菜單內容</h5>
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                        <brand-table />
                        <!-- /.box-body -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import $ from 'jquery'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import brandTableTemp from '../Brand/Temp/BrandTableTemp.vue'
export default {
  name: 'Tables',
  data () {
    return {
      tableIndex: 1
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    }
  },
  components: {
    'brand-table': brandTableTemp
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// MenuTable.vue?46466b7a